import React, { useState , useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import { connect } from 'react-redux';
import {doSearch} from './HeaderSearchSlice';
import Property from '@episerver/spa-core/Components/Property'

const headerSearchDesktop = (props) => {
  const [inputText, setInputText] = useState('');
  let searchTimeout;

  useEffect(() => {
    if(inputText.length >= 3){
      if (searchTimeout != undefined) clearTimeout(searchTimeout);
      searchTimeout = setTimeout( () => {props.doSearch({value : inputText})}, 500);
    }
   }, [inputText]);

  function changeHandler(e){
    setInputText(e.value);
  }

  function close(){
    props.closeHeader();
  }

  function clickOnSearchResult(url){
    props.closeHeader();
    window.location.assign(url);
  }

  function getHighlightedText(text) {
      // Split on highlight term and include term into parts, ignore case
      const parts = text.split(new RegExp(`(${inputText})`, 'gi'));
      return <span> { parts.map((part, i) =>
          <span key={i} style={part.toLowerCase() === inputText.toLowerCase() ? { color: 'white' } : {} }>
              { part }
          </span>)
      } </span>;
  }

  return (
    <>
      <div className="header-search-desktop clearfix">

        <div className="header-logo-wrapper">
          {props.transactionData?.generalDetails?.family === 'W'
            ? <Property iContent={props.iContent} field="siteLogoCellcomEnergy" context={props.context} />
            : <Property iContent={props.iContent} field="siteLogo" context={props.context} />
          }
        </div>

        <button className="close-search-btn" onClick={()=> close()}>
            <span className="close-text">סגור</span>
            <svg width="2em" height="2em" viewBox="0 0 16 16" className="bi bi-x" fill="var(--theme-primary, #810EA9)" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg>
        </button>

        <div className="input-search-wrapper">
          <input
            onChange={(e) => changeHandler(e.target)}
            name='search'
            type='search'
            placeholder={`חיפוש ב${window.Config.brand_Name_HE}`}
            className='search-desktop'
            aria-label="Search through site content"
            autoComplete="off"
            />
        </div>

        {inputText.length >= 3 && props.searchResult  ? (
          <div className="header-search-result">
              <ul>
                {   props.searchResult.length > 0 ?
                    props.searchResult.map(function(item, i) {
                      return <li key={item.id}><a href={'#'} onClick={() => clickOnSearchResult(item.url)}>{getHighlightedText(item.title)}</a></li>
                    }) : <li>לא נמצאו תוצאות</li>
                }
              </ul>
          </div>
        ) : null}

      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    searchResult : state.headerSearch.searchResult,
    transactionData: state.cellcomTransactionSummary.transactionData,
  }

}

const mapDispatchToProps = {
    doSearch
}

export default connect(mapStateToProps, mapDispatchToProps)(headerSearchDesktop)
